module.exports = require("node:sqlite");